export default class FAROConfig {
  private static _instance: FAROConfig = new FAROConfig();

  private _faro_enabled = "";
  private _faro_api_key = "";
  private _faro_collector_url = "";
  private _faro_app_name = "";
  private _faro_app_version = "";
  private _faro_app_env = "";
  private _faro_cors_url = "";

  constructor() {
    FAROConfig._instance = this;
  }

  public static getInstance(): FAROConfig {
    return FAROConfig._instance;
  }

  public setData(
    faro_enabled: string,
    faro_api_key: string,
    faro_collector_url: string,
    faro_app_name: string,
    faro_app_version: string,
    faro_app_env: string,
    faro_cors_url: string
  ): void {
    this._faro_enabled = faro_enabled;
    this._faro_api_key = faro_api_key;
    this._faro_collector_url = faro_collector_url;
    this._faro_app_name = faro_app_name;
    this._faro_app_version = faro_app_version;
    this._faro_app_env = faro_app_env;
    this._faro_cors_url = faro_cors_url;
  }

  public async getConfig(): Promise<{
    faro_enabled: string;
    faro_api_key: string;
    faro_collector_url: string;
    faro_app_name: string;
    faro_app_version: string;
    faro_app_env: string;
    faro_cors_url: string;
  }> {
    let response;
    if (
      process.env.REACT_APP_FARO_ENABLED &&
      process.env.REACT_APP_FARO_COLLECTOR_URL
    ) {
      response = {
        faro_enabled: process.env.REACT_APP_FARO_ENABLED || "false",
        faro_api_key: process.env.REACT_APP_FARO_API_KEY || "",
        faro_collector_url: process.env.REACT_APP_FARO_COLLECTOR_URL || "",
        faro_app_name: process.env.REACT_APP_NAME || "",
        faro_app_version: process.env.REACT_APP_VERSION || "",
        faro_app_env: process.env.REACT_APP_ENV || "",
        faro_cors_url:
          process.env.REACT_APP_FARO_CORS_URL ||
          "^https://.*.albertsons.com.*$",
      };
    } else if (this.getFaroEnabled() && this.getCollectorURL()) {
      response = {
        faro_enabled: this.getFaroEnabled(),
        faro_api_key: this.getFaroAPIKey(),
        faro_collector_url: this.getCollectorURL(),
        faro_app_name: this.getAppName(),
        faro_app_version: this.getAppVersion(),
        faro_app_env: this.getAppEnv(),
        faro_cors_url: this.getCorsURL(),
      };
    } else {
      const baseFaroData = await fetch(`/cost-change/faro/config`);
      response = await baseFaroData.json();
      this.setData(
        response.faro_enabled,
        response.faro_api_key,
        response.faro_collector_url,
        response.faro_app_name,
        response.faro_app_version,
        response.faro_app_env,
        response.faro_cors_url
      );
    }
    return response;
  }

  public getFaroEnabled(): string {
    return this._faro_enabled;
  }
  public getFaroAPIKey(): string {
    return this._faro_api_key;
  }
  public getCollectorURL(): string {
    return this._faro_collector_url;
  }
  public getAppName(): string {
    return this._faro_app_name;
  }
  public getAppVersion(): string {
    return this._faro_app_version;
  }
  public getAppEnv(): string {
    return this._faro_app_env;
  }
  public getCorsURL(): string {
    return this._faro_cors_url;
  }
}
